module.exports = __webpack_public_path__ + "static/adineuePRO-RegularItalicWeb-6fd6d2fb2835b54b70a9cbbfc8455cf0.woff";